<div class="pu-control">
  <div class="pu-control__content">
    <div
      #host
      class="pu-control__input pu-control__input_textarea pu-finance-question-editor"
      [class.pu-finance-question-editor_empty]="readOnly()"
      [attr.contenteditable]="readOnly() ? null : true"
      [id]="controlId"
      (focus)="isFocused.set(true)"
      (blur)="isFocused.set(false)"
    ></div>

    @if (label()) {
      <label
        class="pu-control__label pu-control__label_textarea pu-control__label_active"
        [for]="controlId"
      >{{ label() }}</label>
    }

    <pu-floating-label-outline
      [hasGap]="true"
      [label]="label()"
      [isHighlighted]="isFocused()"
    />
  </div>
</div>
